import DottedList from "../../../../../ui/dottedList";
import Button from "../../../../../ui/button";
import { toPercent, toReadablePrice } from "../../../../../../lib/utils";
import { IMortgageInfo } from "../../../interfaces";
import { useDataEstimateContext } from "../../../hooks/useModalContex";
import style from "../styles.module.scss";
import ModalRedirectToPageWizardTradeIn from "../../modals/modalRedirectToPageWizardTradeIn";
import useOpenModal from "../../../../../ui/modal/hooks/useOpenModal";
import ModalRedirectToPageWizardBuy from "../../modals/modalRedirectToPageWizardBuy";

interface IBuyEstimateProps {
  averageMarketPrice: string;
  mortgageInfo: IMortgageInfo;
  isSecondary: boolean;
}

const BuyEstimate = ({
  averageMarketPrice,
  mortgageInfo,
  isSecondary,
}: IBuyEstimateProps) => {
  const { dataModal } = useDataEstimateContext();

  const {
    open: openTradeIn,
    offsetY: offsetYTradeIn,
    handleChangeModal: handleChangeModalTradeIn,
  } = useOpenModal();

  const {
    open: openBuy,
    offsetY: offsetYBuy,
    handleChangeModal: handleChangeModalBuy,
  } = useOpenModal();

  return (
    <div className={style.buy}>
      <div className={style.buy__container}>
        <div className={style.buy__dotedList}>
          <DottedList
            items={[
              { label: "Стоимость объекта", value: averageMarketPrice },
              {
                label: "Ставка по ипотеке",
                value: toPercent(mortgageInfo.percent),
              },
              {
                label: "Срок кредитования",
                value: mortgageInfo.periodMonth + " мес.",
              },
            ]}
          />
        </div>

        <div className={style.buy__table}>
          <table width={"100%"}>
            <thead>
              <tr>
                <th colSpan={2}>Первоночальный взнос</th>
                <th>Ежемесячный платеж</th>
              </tr>
            </thead>
            <tbody>
              {mortgageInfo.calculations.map((calculation) => {
                return (
                  <tr key={calculation.monthlyPayment}>
                    <td>{toPercent(calculation.initialPaymentPercent)}</td>
                    <td>{toReadablePrice(calculation.initialPayment)}</td>
                    <td>{toReadablePrice(calculation.monthlyPayment)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className={style.buy__buttons}>
          <Button
              label="Купить с экспертом"
              variant="dark"
              onClick={()=>handleChangeModalBuy(true)}
            />
          <Button
            label="Купить в ТРЕЙД-ИН"
            onClick={() => handleChangeModalTradeIn(true)}
          />
        </div>

        <ModalRedirectToPageWizardTradeIn
          offsetY={offsetYTradeIn}
          isOpen={openTradeIn}
          onDismiss={() => handleChangeModalTradeIn(false)}
        />

        {isSecondary && (
          <ModalRedirectToPageWizardBuy
            offsetY={offsetYBuy}
            isOpen={openBuy}
            onDismiss={() => handleChangeModalBuy(false)}
          />
        )}

        {/* <div className={style.buy__accompanimentReit}>
          <AccompanimentReitEstimate />
        </div> */}
      </div>
    </div>
  );
};

export default BuyEstimate;
